import { useRoutes } from 'react-router';

import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';

export default function Routes() {
    return useRoutes([MainRoutes, AuthRoutes]);
}